/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials-slider' ).each( function( key, component ) {
        const images = new Splide( $( component ).find( '.splide--testimonial-images' )[0], {
          pagination: false,
          arrows: false,
          perPage: 1,
          keyboard: true,
        } );

        const contents = new Splide( $( component ).find( '.splide--testimonial-contents' )[0], {
          pagination: false,
          perPage: 1,
          autoHeight: true,
          keyboard: true,
        } );

        images.sync( contents );
        images.mount();
        contents.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.splide__arrows' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.splide__arrows' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.splide__arrows' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.splide__arrows' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
